













































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class DisableCampaign extends Vue {
  @Prop() onConfirm!: any;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleConfirm() {
    this.handleClose();
    this.onConfirm();
  }

  get tPrefix() {
    return 'customerImport.overview.modals';
  }
}
